import { combineReducers } from 'redux-immutable';

import asset from './asset.duck';

export default combineReducers({
  asset
});
